// src/components/LoginPromptBanner.tsx
import React, { useState } from 'react';
import { Box, Typography, Button, IconButton, Collapse } from '@mui/material';
import { Google as GoogleIcon, Close as CloseIcon } from '@mui/icons-material';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { auth } from '@/firebase';
import { useAuth } from '@/contexts/AuthProvider';
import AppleSignInButton from './AppleSignInButton';

const LoginPromptBanner: React.FC = () => {
  const { user } = useAuth();

  // sessionStorageから閉じた状態を取得
  const getInitialVisibility = () => {
    try {
      return sessionStorage.getItem('loginBannerClosed') !== 'true';
    } catch (e) {
      return true;
    }
  };

  const [isVisible, setIsVisible] = useState(getInitialVisibility);

  // ログイン済みの場合は表示しない
  if (user) {
    return null;
  }

  // バナーを閉じた場合は表示しない
  if (!isVisible) {
    return null;
  }

  const handleLogin = async () => {
    const provider = new GoogleAuthProvider();
    try {
      await signInWithPopup(auth, provider);
      // サインイン後は AuthProvider の onIdTokenChanged が発火
    } catch (error) {
      console.error('Googleログインでエラーが発生しました:', error);
    }
  };

  const handleClose = () => {
    setIsVisible(false);
    // セッションストレージに閉じた状態を保存（リロードで再表示）
    try {
      sessionStorage.setItem('loginBannerClosed', 'true');
    } catch (e) {
      // sessionStorageが使えない場合は無視
    }
  };

  return (
    <Collapse in={isVisible}>
      <Box
        sx={{
          backgroundColor: '#000',
          border: '2px solid #fff',
          borderRadius: 0,
          padding: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 2,
          flexWrap: 'wrap'
        }}
      >
        <Typography
          variant="body2"
          sx={{
            flex: '1 1 auto',
            color: '#fff'
          }}
        >
          Googleログインをすることで学習が記録できます
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
          <AppleSignInButton
            label="Appleでサインイン"
            size="small"
            sx={{ border: '1px solid #fff' }}
          />
          <Button
            variant="contained"
            color="primary"
            size="small"
            startIcon={<GoogleIcon />}
            onClick={handleLogin}
            sx={{
              whiteSpace: 'nowrap',
              backgroundColor: '#4285f4',
              '&:hover': {
                backgroundColor: '#357ae8'
              }
            }}
          >
            Googleでログイン
          </Button>
          <IconButton
            aria-label="close"
            size="small"
            onClick={handleClose}
            sx={{
              color: '#fff'
            }}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </Box>
      </Box>
    </Collapse>
  );
};

export default LoginPromptBanner;
